module.exports = __webpack_public_path__ + "static/media/check.49038605.svg";